<script setup lang="ts">
import { computed } from "vue";
import Tag from "~/components/Common/Tag.vue";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";

const props = defineProps<{
  tag?: {
    value: string;
    type: ColorsTypeEnum | string;
    strikethrough?: boolean;
  };
  /** 12px text, for pills inside dense cards. */
  small?: boolean;
}>();

// A status is marked by its dot alone: drop the logo or icon some status mappings still carry.
// Without a label there is no chip, or its dot would show on its own (a draft session has no status).
const statusTag = computed(() =>
  props.tag?.value
    ? { value: props.tag.value, type: props.tag.type, strikethrough: props.tag.strikethrough }
    : undefined,
);
</script>

<template>
  <Tag v-if="statusTag" :tag="statusTag" :small="small" dot />
</template>
